#content
<template>
	<div class="content-wrapper">
		<div class="sf-flex-column h-100">
			<div class="sf-col sf-col-4">
				<sf-card class="p-0 h-100 card_bg">
					<search-view ref="searchView" @Refresh="refresh" :scrId="scrId"></search-view>
				</sf-card>
			</div>
			<div class="sf-col sf-col-20">
				<sf-card class="p-0 border-0 bg-transparent h-100">
					<table-view ref="tableView" @OpenCofPopup="OpenCofPopup" :sendParam="sendParam" @Refresh="refresh" :scrId="scrId"></table-view>
				</sf-card>
			</div>
			<comp-popup ref="compPopup" @SendData="sendData" :scrId="scrId"></comp-popup>
		</div>
	</div>
</template>

<script>
import SearchView from './Search/Search';
import TableView from './Table/Table';
import CompPopup from '@qms/comm/commpopup/CompPopup/CompPopup.vue';
export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			sendParam: {} //협력사 팝업
		};
	},
	components: { SearchView, TableView, CompPopup },
	methods: {
		refresh() {
			this.$refs.searchView.searchList();
		},
		//협력사 팝업 오픈
		OpenCofPopup(param) {
			const params = {
				cpnyScn: param.cpnyScn,
				cpnyCd: param.cpnyCd
			};
			this.$refs.compPopup.open(params); //.open(param);
		},
		sendData(param) {
			this.sendParam = param; //watch감시용
		}
	}
};
</script>

<style></style>
